// Auth
export const TOT = 'tot'
export const SIGN_UP = 'signup'
export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const GUEST_SIGN_UP = 'signupGuest'
export const SEND_VERIFICATION_EMAIL = 'sendVerificationEmail'
export const VERIFY_EMAIL = 'verifyEmail'
export const CHANGE_PASSWORD = 'changepassword'
export const RESET_PASSWORD = 'resetpassword'
export const UPDATE_LAST_LOGIN = 'updateLastLogin'
export const USER_ROLE = 'userrole'
export const PASS = 'pass'
export const AUTH_KEYCLOAK_BY_ID = 'authkeycloakbyid'
export const EXCHANGE_TOKEN = 'exchangetoken'
export const ORGANISATIONS = 'selectUserGroups'
export const GET_CERTS = 'getCerts'
export const GET_PUBLIC_CERT = 'getPublicCert'
export const RECAPTCHA = 'recaptcha'
export const AUTH_CHECK = 'authCheck'
export const USER_PERMISSIONS = 'userPermissions'

// Seasons and Age Groups
export const AGEGROUPS = 'ageGroups'
export const AGEGROUPS_SEASONS = 'ageGroupsSeasons'
export const SEASONS = 'seasons'

// Clearances
export const CLEARANCES = 'clearances'
export const CLEARANCE_REQUEST_ACTION = 'approveOrRejectClearanceRequest'
export const CLEARANCE_AVAILABLE_MEMBERS = 'availableClearanceMembers'
export const CLEARANCES_REQUEST_FOR_ID = 'clearanceRequestForId'

// Marketplace
export const MARKETPLACE_PRODUCTS = 'marketplaceProducts'
export const MARKETPLACE_PRODUCT_STATUS = 'marketplaceProductStatus'
export const ACTIVATE_INTEGRATION = 'marketplaceProductStatus'
export const DEACTIVATE_INTEGRATION = 'marketplaceProductStatus'
export const MANAGE_INTEGRATION = 'marketplaceManageProduct'

// Reports
export const POWERBI_CONFIG = 'powerbiConfig'
export const POWERBI_OAUTH = 'powerbiOauth'
export const REPORTS = 'tabularReports'
export const REPORT_TYPES = 'tabularReportTypes'
export const REPORT_FIELDS = 'tabularReportFields'
export const REPORT_DETAILS = 'tabularReportDetails'
export const REPORT_EMAIL_TO = 'tabularReportEmailTo'
export const REPORT_PREVIEW = 'tabularReportPreview'
export const REPORT_DELETE = 'tabularReportDelete'

// Vouchers
export const VOUCHER_SETTINGS = 'voucherSettings'
export const VOUCHER_SESSIONS = 'voucherSessions'
export const VOUCHER_SESSIONS_FIND = 'findVoucherSessions'
export const VOUCHER_REDEEM = 'redeemVoucher'
export const VOUCHER_VALIDATE_VIC = 'validateVICVoucher'
export const VOUCHER_VALIDATE_NSW = 'validateNSWVoucher'

// Communications
export const GET_EMAIL_LETTERHEADS = 'getEmailLetterheads'
export const POST_EMAIL_LETTERHEADS = 'postEmailLetterheads'
export const GET_EMAIL_LETTERHEADS_DETAILS = 'getEmailLetterheadDetails'
export const SENT_EMAILS = 'sentEmails'
export const COMMUNICATION_DETAILS = 'communicationDetail'
export const EMAIL_RECIPIENTS = 'sentEmailRecipients'
export const GET_EMAIL_TEMPLATES = 'getEmailTemplates'
export const POST_EMAIL_TEMPLATES = 'postEmailTemplate'
export const GET_EMAIL_TEMPLATE = 'getEmailTemplate'
export const RESEND_INVOICE_EMAIL = 'resendInvoiceEmail'
export const SEND_BULK_EMAILS = 'sendBulkEmails'
export const REPLY_TO_EMAIL = 'replyToEmail'
export const REPLY_TO_EMAIL_VERIFY = 'replyToEmailVerify'
export const REPLY_TO_EMAIL_RESEND = 'replyToEmailResend'
export const REPLY_TO_EMAIL_DELETE = 'replyToEmailDelete'
export const REPLY_TO_EMAIL_OTP_STATUS = 'replyToEmailOtpStatus'

// Discounts
export const DISCOUNTS = 'discounts'
export const DISCOUNTS_DETAILS = 'getDiscountByIdDetails'
export const DISCOUNTS_DETAILS_AMOUNT = 'getDiscountByIdAmounts'
export const DISCOUNTS_DETAILS_PRODUCTS = 'getDiscountByIdProducts'
export const DISCOUNT_NAMES = 'discountNames'

// Events
export const EVENTLANDING_PAGE = 'getLandingPage'
export const EVENTS = 'events'
export const EVENTTEMPLATES = 'eventTemplates'
export const EVENTTEMPLATES_DETAILS = 'eventTemplatesDetails'
export const EVENT_FORM_VALIDATE = 'eventFormValidate'
export const EVENT_DETAILS = 'eventDetails'
export const EVENT_ATTENDANCE = 'eventAttendance'
export const EVENT_PARTICIPANTS = 'eventParticipants'
export const EVENT_PARTICIPANTS_BY_ADDON_PRODUCTS = 'eventParticipantsByAddOnProducts'
export const EVENT_PARTICIPANTS_BY_TEAM = 'eventParticipantsByTeam'
export const EVENT_PARTICIPANTS_BY_SUBEVENT = 'eventParticipantsBySubEvent'
export const REORDER_SUBEVENTS = 'reorderSubEvents'
export const SUBEVENTS = 'subEvents'
export const UPDATE_SUBEVENT = 'updateSubEvent'
export const EVENT_QR_POSTER = 'eventQrPoster'
export const HAS_SHARED_EVENTS = 'hasSharedEvents'
export const EVENT_PRODUCTS = 'eventProducts'

// File Upload/Download
export const FILE_DELETE = 'fileDelete'
export const FILE_DOWNLOAD = 'fileDownload'
export const FILE_UPLOAD = 'fileUpload'

// Forms
export const FORMS = 'forms'
export const FORMS_BUNDLE_DISCOUNTS = 'formBundleDiscounts'
export const GET_FORM_DETAILS = 'getFormDetails'
export const DISPLAY_SETTINGS = 'displaysettings'
export const UPDATE_FORM = 'formUpdate'
export const FORM_MESSAGES = 'formMessages'
export const FORM_PRODUCT_GROUPS = 'formProductGroups'
export const FORM_PRODUCTS = 'formProducts'
export const FORM_PRODUCT_MOVE = 'formProductMove'
export const FORM_PRODUCT_VALIDATE = 'formProductValidate'
export const FORM_PUBLISH = 'formPublish'
export const FORM_QUESTION_DETAILS = 'formQuestionDetails'
export const FORM_QUESTIONS = 'formQuestions'
export const FORM_QUESTION_VALIDATE = 'formQuestionValidate'
export const VALIDATE_SESSIONS = 'validateSessions'
export const GET_FORM_SETTINGS = 'getFormSettings'
export const FORM_SIMPLE = 'formsSimple'
export const GET_AP_FORM_DETAILS = 'getAPFormDetails'
export const FORM_QR_POSTER = 'formQrPoster'

// Integrations
export const MAILCHIMP_AUDIENCE_LIST = 'mailchimpLists'
export const MAILCHIMP_AUTH = 'mailchimpAuth'

// Members
export const MEMBERS = 'postMembers'
export const MEMBERS_PENDING = 'pendingMemberAction'
export const MEMBERS_EVENT_ADDON_PRODUCTS = 'memberEventAddOnProducts'
export const MEMBERS_BY_ADDON_PRODUCTS = 'getMemberListByAddOnProducts'
export const MEMBERS_BY_FINANCIAL = 'getMembersListByFinancial'
export const MEMBERS_BY_MEMBER_TYPE = 'getMembersListByMemType'
export const MEMBERS_BY_ORGANISATION = 'getMembersListByOrg'
export const MEMBERS_BY_PENDING = 'getMembersListByPending'
export const MEMBERS_BY_PRODUCT = 'getMembersListByProduct'
export const MEMBERS_BY_SEASON = 'getMemberListBySeason'
export const MEMBER_CLEARANCES = 'memberClearances'
export const MEMBER_DETAILS = 'memberDetails'
export const MEMBER_DOCUMENTS = 'memberDocuments'
export const MEMBER_EMAILS = 'memberEmails'
export const MEMBER_EVENT_PRODUCTS = 'memberEventProducts'
export const MEMBER_EVENT_REGISTRATIONS = 'memberEventRegistrations'
export const MEMBER_FORM_ANSWERS = 'memberFormAnswers'
export const MEMBER_FORMS = 'memberForms'
export const MEMBER_MEMBERSHIP_ID = 'memberID'
export const MEMBER_MEMBERSHIP_NUMBERS = 'memberNumbers'
export const MEMBER_MEMBERSHIPS = 'memberMemberships'
export const MEMBER_MEMBER_TYPES = 'memberMemberTypes'
export const MEMBER_NOTES = 'memberNotes'
export const MEMBER_ORDERS = 'memberOrders'
export const MEMBER_ADD_FORM = 'memberAddForm'
export const MEMBERS_LIST = 'getMembersList'
export const MEMBERS_VALIDATE_ACCOUNT_EMAIL = 'validateMemberAccountEmail'
export const MEMBERS_UPDATE_ACCOUNT_EMAIL = 'updateMemberAccountEmail'
export const MEMBERS_BY_MEMBER_TYPE_PRODUCT_OWNERS = 'memberTypeProductOwners'
export const MEMBER_KEY_DATES = 'memberKeyDates'

// Orders
export const ORDERS_LIST = 'orderList'
export const CANCEL_ORDER = 'orderCancel'
export const CREATE_ORDER = 'orderCreate'
export const ORDER_DETAILS = 'orderDetail'
export const GET_MEMBERSHIP_ORDER_ITEM = 'getMembershipOrderItem'
export const GET_LIST_FINANCES_ORDER_ITEMS = 'getListFinancesOrderItems'
export const ORDER_RECALCULATE = 'orderRecalculate'
export const ORDER_REFUND = 'orderRefund'
export const ORDER_STATUS = 'orderStatus'
export const ORDER_TRANSACTION_ITEMS = 'transactionItems'
export const ORDER_TRANSACTIONS = 'transactions'
export const ORDER_NOTES = 'orderNotes'
export const ORDER_NOTE_CREATE = 'orderNoteCreate'
export const ORDER_NOTE_UPDATE = 'orderNoteUpdate'

// Organisations
export const ORG_CONTACT_ADMIN = 'orgContactAdmin'
export const ORG_CONTACTS = 'orgContacts'
export const ORG_CONTACTS_PREFERENCES = 'orgContactsPreferences'
export const ORG_CUSTOMER_ORG = 'orgCustomerOrg'
export const ORG_DETAILS = 'orgDetails'
export const ORG_DOCUMENTS = 'orgDocuments'
export const ORG_LISTS = 'getListOrg'
export const ORG_TYPES = 'orgTypes'
export const ORG_CHECK_CONTACT_EMAIL = 'checkContactEmail'
export const ORG_ORGCONTACTSLIST = 'orgContactsList'

// User Management
export const USER_MANAGEMENT = 'usermanagement'
export const USER_MANAGEMENT_ROLES = 'usermanagementroles'

// Member Types
export const GET_MEMBER_TYPES = 'getMemberTypes'
export const SAVE_MEMBER_TYPES = 'saveMemberTypes'

// Products
export const PRODUCTS = 'products'
export const PRODUCT_CLONE = 'cloneProduct'
export const PRODUCT_DETAILS = 'getProductById'
export const PRODUCT_DETAILS_ASSIGNED_SEASONS = 'saveProductAssignedSeasons'
export const PRODUCT_DETAILS_CONDITIONAL_PRODUCTS = 'productConditionalProductsById'
export const GET_PRODUCT_DETAILS_DISPLAY_RULES = 'productDisplayRulesById'
export const SAVE_PRODUCT_DETAILS_DISPLAY_RULES = 'saveProductDisplayRules'
export const PRODUCT_DETAILS_INFO = 'saveProductBasicInfo'
export const GET_PRODUCT_DETAILS_MEMBERTYPES = 'productMemberTypesById'
export const SAVE_PRODUCT_DETAILS_MEMBERTYPES = 'saveProductMemberTypes'
export const PRODUCT_DETAILS_ATTRIBUTES = 'productAttributesById'
export const PRODUCT_DETAILS_RELATED_DISCOUNTS = 'productRelatedDiscountsById'
export const PRODUCT_DETAILS_RELATED_FORMS = 'productRelatedFormsById'
export const PRODUCT_NAMES = 'productNames'
export const BULK_PRODUCT_DETAILS = 'bulkProductDetails'
export const BULK_PRODUCT_CREATE = 'bulkProductCreate'

// Questions
export const QUESTIONS = 'questions'
export const QUESTION_DETAILS = 'questionDetails'
export const EVENT_PASS_APPLE = 'eventPassApple'
export const EVNET_PASS_GOOGLE = 'eventPassGoogle'
export const GET_CLIENT_TOKEN = 'getClientToken'
export const SUBMIT_PAYMENT = 'submitPayment'
export const PAYPAL_ORDER = 'paypalOrder'

// Product Attributes
export const PRODUCTATTRIBUTES = 'productAttributes'
export const PRODUCTATTRIBUTES_DETAILS = 'productAttributesDetails'

// Promocodes
export const PROMOCODES = 'promocodes'
export const PROMOCODE_ASSIGN_CODES = 'promocodeAssignCodes'
export const PROMOCODE_VALUES = 'promocodeValues'
export const GET_PROMOCODE_DETAILS = 'getPromocodeByIdDetails'
export const UPDATE_PROMOCODE_DETAILS = 'updatePromoCode'
export const PROMOCODE_DETAILS_APPLYTO = 'getPromocodeByIdApplyTo'
export const PROMOCODE_DETAILS_ASSIGNMENT = 'getPromocodeByIdAssignment'
export const PROMOCODE_DETAILS_MEMBERS = 'getPromocodeByIdMembers'
export const PROMOCODE_DETAILS_MESSAGES = 'getPromocodeByIdMessages'
export const PROMOCODE_DETAILS_USAGE = 'getPromocodeByIdUsage'
export const PROMOCODES_EMAIL_TEMPLATE = 'promocodeEmailTemplate'
export const PROMOCODES_SESSIONS = 'promocodeSessions'
export const PROMOCODES_VALIDATE = 'promocodeValidate'

// Registrations
export const SUBMIT_REGISTRATION = 'submitRegistration'
export const GET_PAY_REGISTRATION = 'getPayRegistration'
export const UPDATE_REGISTRATION = 'updateRegistrations'
export const REGISTRATIONS_TICKET = 'registrationsTicket'
export const SCAN = 'scan'

// Financial Settings
export const SETTINGS_BANK_DETAILS = 'bankDetails'
export const SETTINGS_FEE_CONFIGURATIONS = 'feeConfigurations'
export const SETTINGS_PAYMENT_GATEWAYS = 'paymentGateways'
export const SETTINGS_PROCESSING_FEES = 'processingFees'
export const SETTINGS_REFUND_PERIOD = 'refundPeriod'
export const SETTINGS_RELATED_SETTLEMENTS = 'getListRelatedSettlements'

// Payment
export const APPLE_PAY_DOMAIN = 'adddeleteapplepaydomain'
export const PAYMENT_METHOD_DELETE = 'deletePaymentMethod'
export const GET_PAYMENT_METHODS = 'getPaymentMethods'
export const GET_REGISTERED_APPLE_PAY_DOMAINS = 'getregisteredapplepaydomains'

// Settlements
export const SETTLEMENTS = 'settlementList'
export const SETTLEMENTS_ITEMS = 'getSettlementItems'
export const SETTLEMENTS_INVOICE = 'settlementInvoice'
export const SEND_PAYMENT_REQUESTS = 'sendPaymentRequests'

// ID Rules/Management
export const SETTINGS_ID_GENERATION_RULES = 'idGenerationRules'
export const SETTINGS_MEMBER_ID_RULES = 'memberIDRules'
export const SETTINGS_UPDATE_PRIMARY_RULE = 'idGenSetPrimary'

// Teams
export const TEAMS = 'teams'
export const TEAMS_BY_CODE = 'getTeamsByCode'
export const TEAMS_BY_EVENT = 'getTeamsInEvent'
export const TEAMS_BY_USER = 'getTeamsByUser'
export const GET_TEAM_DETAILS = 'getTeamDetails'
export const UPDATE_TEAM_DETAILS = 'updateTeamDetails'
// Teams (continued)
export const TEAMS_EVENTS_BY_TEAM = 'getEventsByTeam'
export const TEAMS_PARTICIPANTS_BY_EVENT = 'getTeamParticipants'
export const TEAMS_PARTICIPANTS_BY_TEAM = 'getParticipantsByTeam'
export const TEAMS_PARTICIPANTS_BY_PAYMENT_STATUS = 'getParticipantsByPaymentStatus'
export const TEAMS_SEND_EMAIL = 'sendEventEmail'
export const TEAMS_SUB_EVENTS_BY_TEAM = 'getSubEventsByTeam'
export const TEAMS_TEAM_CODES = 'teamsTeamCodes'
export const TEAMS_TEAM_MANAGER = 'teamsTeamManager'
export const EVENTS_BY_TEAM = 'eventsByTeam'

// Member Renewals
export const RENEWAL_CAMPAIGNS = 'renewalCampaigns'
export const RENEWAL_CAMPAIGNS_DETAILS = 'renewalCampaignsDetailed'
export const RENEWAL_CAMPAIGNS_SCHEDULE = 'renewalCampaignsSchedule'
export const RENEWAL_CAMPAIGNS_MEMBERS = 'renewalCampaignsMembers'
export const RENEWAL_CAMPAIGNS_DETAILS_CANCEL = 'renewalCampaignsDetailCancel'

// Campaigns
export const CAMPAIGNS_MEMBERS = 'campaignsMembers'
export const CAMPAIGNS_MEMBERSHIPPAYMENT = 'campaignsMembershipPayment'
export const CAMPAIGNS_MEMBERSHIPPAYMENT_DETAILS = 'campaignsMembershipPaymentDetails'
export const CAMPAIGNS_MEMBERSHIPPAYMENT_PREV_PURCHASED_PRODUCTS = 'campaignsMembershipPaymentPrevPurchasedProducts'
export const CAMPAIGNS_MEMBERSHIPPAYMENT_RENEWAL_PRODUCTS = 'campaignsMembershipPaymentRenewalProducts'
export const CAMPAIGNS_MEMBERSHIPPAYMENT_SCHEDULE = 'campaignsMembershipPaymentSchedule'

// Customer Plans
export const CUSTOMERPLANS = 'customerPlans'
export const CUSTOMERPLANS_DETAILS = 'customerPlanDetailed'
export const CUSTOMERPLAN_PERMISSIONS = 'customerPlanPermissions'
export const ORGSUBSCRIPTION = 'orgSubscription'
export const CUSTOMERPLANS_COPY = 'customerPlansCopy'

// Other
export const USER_PROFILE = 'userProfile'
export const USER_ACCOUNT = 'userAccount'
export const UPDATE_USER_ACCOUNT = 'updateUserAccount'
export const EXPORTS = 'exports'
export const REPROCESS_EXPORTS = 'reprocessExports'
export const EXPORT_CSV = 'exportCSV' // possibly deprecated
export const GLOBAL_SEARCH = 'globalSearch'
export const SUBDIVISION = 'subdivision'
export const SYSTEM_ALERT = 'getSystemAlert'

// GDP Events
export const GET_TEAM_EVENT = 'getTeamEvents'
export const GET_EVENT_PARTICIPANTS = 'getEventParticipants'
export const GET_PRODUCTS = 'getProducts'
export const GET_TEAM_MANAGER = 'teamsTeamManager'
export const AUTH_LOGIN = 'authLogin'
export const AUTH_LOGOUT = 'authLogout'

// GDP Registrations
export const BASIC_DISPLAY_SETTINGS = 'getBasicDisplaySettings'
export const REGISTRATIONS_ORDER_DETAILS = 'getOrderDetails'
export const MAGICLINK_RESOLVE = 'magiclinkResolve'
export const VALIDATE_OTP = 'validateOTP'
export const ORG_DISPLAY_SETTINGS = 'orgDisplaySettings'
export const ROKT_CONFIG = 'roktConfig'

// Accreditations
export const ACCREDITATIONS = 'accreditations'
export const MEMBERS_BY_ACCREDITATIONS = 'membersByAccreditations'
export const ACCREDITATIONS_DETAILS = 'accreditationDetails'
export const MEMBER_ACCREDITATIONS = 'memberAccreditations'
export const CREATE_MEMBER_ACCREDITATIONS = 'createMemberAccreditation'
export const UPDATE_MEMBER_ACCREDITATIONS = 'updateMemberAccreditation'

// Misc
export const CACHE_KEY = 'endpointURLs'
export const UPDATE_TOKEN = 'updatetoken'
export const ENDPOINTS = 'endpoints'
export const BASE_ENDPOINTS = 'common/endpoints'
export const ENDPOINTS_TTL = 86400
export const API_BASE_GATEWAY_ADMIN_PORTAL = 'gamedayapi/'

// Stripe
export const STRIPE_PAYMENT_INTENT = 'stripePaymentIntent'
export const STRIPE_PAYMENT_STATUS = 'stripePaymentStatus'
export const STRIPE_CONNECT_STATUS = 'stripeConnectStatus'
export const STRIPE_CONNECT_ONBOARD = 'stripeConnectOnboard'
export const STRIPE_CONNECT_UPDATE = 'stripeConnectUpdate'

// Member Profile
export const MEMBER_PROFILE_DETAILS = 'memberProfileDetails'
export const USER_MEMBER_PROFILES = 'memberProfilesByUser'
export const MEMBER_PROFILE_HIERARCHY_SETTINGS = 'memberProfileHierarchySettings'

// Duplicate Management
export const DUPLICATES = 'duplicates'
export const RESOLVE_DUPLICATES = 'resolveDuplicates'

// Notifications
export const NOTIFICATIONS = 'notifications'
